// --------------------------------------------------------------------------
// Mobile only toggle using matchMedia
// --------------------------------------------------------------------------
// Author:      Alix Richards
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {
        var mobileMQ = window.matchMedia('(max-width: 768px)');
        var $buttonToggle = context.find('[data-binding="mobile-toggle-button"]');
        var $paragraphToggle = context.find('[data-binding="mobile-toggle-copy"]');

        if (mobileMQ) {
            $buttonToggle.on('click', function () {
                $paragraphToggle.toggleClass('is-visible');
                var text = $(this).text() === 'Show' ? 'Hide' : 'Show';
                $(this).text(text);
            });
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/mobile-text-toggle.js
// module id = 266
// module chunks = 0